/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Copilot_Risk_Actions_TitleInputs */



/**
* | output |
* | --- |
* | "Risk Level Actions" |
*
* @param {Compliance_Copilot_Risk_Actions_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_copilot_risk_actions_title = /** @type {((inputs?: Compliance_Copilot_Risk_Actions_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Copilot_Risk_Actions_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Risikostufen-Aktionen")
	return /** @type {LocalizedString} */ ("Risk Level Actions")
});